export const customHorizontalData = [
    {
      activeTab: 1,
      iconName: "fa-user",
      tittle: "Personal info",
    },
    {
      activeTab: 2,
      iconName: "fa-chain-broken",
      tittle: "Connect bank account",
    },
    {
      activeTab: 3,
      iconName: "fa-group",
      tittle: "Inquiries",
    },
    {
      iconName: "fa-group",
      tittle: "Completed ",
    },
  ];

  export const popularBankList = [
    {
      imageName: "hdfc.png",
      bankName: "ABC BANK",
    },
    {
      imageName: "Bank-of-Baroda.png",
      bankName: "XYZ BANK",
    },
    {
      imageName: "idbi.png",
      bankName: "PQR BANK",
    },
    {
      imageName: "rbl.png",
      bankName: "DEF BANK",
    },
    {
      imageName: "us-bank.png",
      bankName: "MNO BANK",
    },
    {
      imageName: "axis.png",
      bankName: "WXY BANK",
    },
    {
      imageName: "SCB.png",
      bankName: "STD BANK",
    },
  ];


  export const businessVerticalData = [
    {
      activeTab: 1,
      tittle: "Choose account",
    },
    {
      activeTab: 2,
      tittle: "Business settings",
    },
    {
      activeTab: 3,
      tittle: "Contact details",
    },
    {
      activeTab: 4,
      tittle: "Pay details",
    },
    {
      tittle: "completed",
    },
  ];

  export const selectAmountData = [
    {
      iconName: "fa-university",
      tittle: "Business",
    },
    {
      iconName: "fa-user",
      tittle: "Personal ",
    },
  ];

  export const selectData = ["Technology","Culture","NGO","Environment","Life cycle"]

  export const verticalBoxData = [
    {
      tittle: "Tivo",
      details: "2-3 Members",
    },
    {
      tittle: "Cuba",
      details: "4-5 Members",
    },
    {
      tittle: "Multikart",
      details: "2 Member",
    },
    {
      tittle: "Roxo",
      details: "1 Member",
    },
  ];